import { render, staticRenderFns } from "./FeatureRequestFeed.vue?vue&type=template&id=2ca20d3e&scoped=true&"
import script from "./FeatureRequestFeed.vue?vue&type=script&lang=ts&"
export * from "./FeatureRequestFeed.vue?vue&type=script&lang=ts&"
import style0 from "./FeatureRequestFeed.vue?vue&type=style&index=0&id=2ca20d3e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca20d3e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VDivider,VIcon,VTooltip})
